import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MButton } from "@/components/ui/atoms/MButtons";
import { IconCheck } from "@tabler/icons-react";
import MOnboardingHeader from "@/components/ui/organisms/MOnboardingHeader";
import styles from './consent.module.css';
import MFrame from "@/components/ui/atoms/MFrame";

export default function Consent() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const handleContinue = () => {
    const state = location.state as any;
    const mode = state?.mode || "mobile";
    const passthroughState = state?.fromLogin ? {
      fromLogin: state.fromLogin,
      autoSendOtp: state.autoSendOtp,
      prefillEmail: state.prefillEmail,
      prefillMobile: state.prefillMobile,
      prefillDialCode: state.prefillDialCode,
    } : undefined;
    navigate(`/register/SignupForm/${mode}`, { state: passthroughState });
  };

  return (
    <div className={styles.container}>
      
      <MOnboardingHeader
        currentStep={1}
        totalSteps={3}
        onBack={() => navigate(-1)}
        onExit={() => navigate('/')}
      />

      <div className={styles.content}>
        <h1 className={styles.title}>
          {t('auth.onboarding.consent.title')}
        </h1>
        <p className={styles.subtitle}>
          {t('auth.onboarding.consent.subtitle')}
        </p>

        <MFrame className="block p-[24px]" >
          <div className={styles.consentLabel}>{t('auth.onboarding.consent.confirmLabel')}</div>
          
          <div className={styles.consentItems}>
            <div className={styles.consentItem}>
              <IconCheck size={24} color="#8764BB" className={styles.checkIcon} />
              <p className={styles.consentText}>
                {t('auth.onboarding.consent.consent2')}
              </p>
            </div>
            <div className={styles.consentItem}>
              <IconCheck size={24} color="#8764BB" className={styles.checkIcon} />
              <p className={styles.consentText}>
                {t('auth.onboarding.consent.termsText')}{" "}<a href="https://maatra.health/terms" target="_blank" rel="noopener noreferrer" className={styles.termsLink}>
              {t('auth.onboarding.consent.termsLink')}
            </a>
              </p>
            </div>
          </div>

        </MFrame>
        

        {/* Buttons */}
        <div className={styles.buttonContainer} style={{marginTop: '50px'}}>
          <MButton
            size="lg"
            variant="filled"
            text={t('auth.onboarding.consent.confirm')}
            className="w-full"
            onClick={handleContinue}
          />
        </div>
      </div>
    </div>
  );
}
